import {
	TraversalWithIds,
	ElementComponentData,
} from "../../data/form/elementSelectors";
import { PatchConfig } from "data/form/types"; // TODO: unsure what these any's should be so left them

/* eslint-disable @typescript-eslint/no-explicit-any */ export interface LegacyArrayData {
	[k: string]: {
		value: any[];
	};
}

export function createRows(data: LegacyArrayData[]) {
	const rows: any = [];

	data.forEach((column, index) => {
		Object.keys(column).forEach(key => {
			const value = column[key].value;
			value.forEach((v, i) => {
				if (rows[i] === undefined) rows[i] = {};
				rows[i][key] = v;
			});
		});
	});

	return rows;
}

export type RowData = { [k: string]: ElementComponentData }[];

type AddRowParams = {
	traversal: TraversalWithIds;
	vid: string;
	rowIndex: number;
	data: RowData;
	addCount?: number;
	rowData?: RowData;
};

export const addRow = ({
	traversal,
	vid,
	rowIndex,
	data,
	addCount = 1,
	rowData,
}: AddRowParams) => {
	// Check if any of the columns don't yet exist in the data
	const undefinedColumns = traversal
		.filter(([uuid, id]) => data.findIndex(v => v[id] !== undefined))
		.reduce((result: PatchConfig[], [uuid, id]) => {
			// Create the column
			result.push({
				path: `${id}`,
				op: "add",
				id: `${id}`,
				data: { value: [] },
				uuid,
				rowIndex,
				vid,
			});

			// Null values for all of the previous indexes
			if (data.length > 0) {
				for (let i = 0; i < data.length; i++) {
					const _id = `${id}/${i}`;

					result.push({
						path: _id,
						op: "add",
						id: _id,
						data: { value: null },
						uuid,
						rowIndex,
						vid,
					});
				}
			}

			return result;
		}, []);

	// if we have row data we need to create new rows and fill in any columns that aren't set with null values
	const numberOfAdditionalRows = rowData ? rowData.length : addCount;

	const traversalObject: { [key: string]: PatchConfig[] } = {};

	traversal.forEach(([uuid, _id]) => {
		for (let index = 0; index < numberOfAdditionalRows; index++) {
			const id = `${_id}/${data.length + index}`;
			// If we have row data we attempt to pull the value for this column from it
			// otherwise we default the value to null
			const value = rowData?.[index]?.[_id]?.value || null;
			const newPatch: PatchConfig = {
				path: id,
				op: "add",
				id: id,
				data: { value },
				uuid,
				rowIndex,
				vid,
			};

			if (traversalObject[index] === undefined)
				traversalObject[index] = [newPatch];
			else traversalObject[index].push(newPatch);
		}
	});

	const newRows: PatchConfig[] = [];

	for (const [, value] of Object.entries(traversalObject)) {
		newRows.push(...value);
	}

	return [...undefinedColumns, ...newRows];
};

export const removeRow = (
	index: number,
	traversal: TraversalWithIds,
	vid: string,
	rowIndex: number
) =>
	traversal.reduce((result: PatchConfig[], [uuid, _id]) => {
		result.push({
			path: `${_id}/${index}`,
			op: "remove",
			id: `${_id}/${index}`,
			uuid,
			rowIndex,
			vid,
		});

		return result;
	}, []);
